import { capitalize } from '@/helpers/string';
import { getBreakpointsWithMinMaxValues } from '@/helpers/breakpoints';

const breakpoints = getBreakpointsWithMinMaxValues();

const state = () => ({
  screenWidth: (window || {}).innerWidth || 0,
});

// mutations
const mutations = {
  setScreenWidth(currentState, value) {
    currentState.screenWidth = value;
  },
};

const getters = {
  screenWidth: (currentState) => currentState.screenWidth,

  isBetween: (currentState) => (num1, num2) =>
    num1 < currentState.screenWidth && num2 >= currentState.screenWidth,

  // isSm, isXsm, isMd, isLg, isXl, isXxl
  ...Object.fromEntries(
    breakpoints.map(({ name, min, max }) => [
      `is${capitalize(name)}`,
      (_, g) => g.isBetween(min, max),
    ]),
  ),

  currentBreakpoint: (_, g) =>
    breakpoints.find((breakpoint) => g.isBetween(breakpoint.min, breakpoint.max)),

  isMobile: (currentState, currentGetters) => currentGetters.isXsm || currentGetters.isSm,
  isMdMax: (currentState, currentGetters) =>
    currentGetters.isMd || currentGetters.isXsm || currentGetters.isSm,
};

export default {
  namespaced: true,

  mutations,
  state,
  getters,
};
